var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),(_vm.viewstate===0)?_c('Pengajuan'):_vm._e(),(_vm.viewstate===9)?_c('SedangMenunggu'):_vm._e(),(_vm.viewstate===1)?_c('Loanformrequest'):_vm._e(),(_vm.viewstate===2)?_c('Dashboardcapital'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }